import React, { useState, useMemo } from 'react';

import EmployeeOwnerAvatar from 'components/EmployeeOwnerAvatar';
import MeshListEmployeeEditPopup from 'components/MeshListEmployeeEditPopup';

import { generateKey } from 'constants/helper';

import { selectCollaborators, selectOwners } from 'services/helpers/task';

import NodesViewV2 from './NodesViewV2';

function sortToIdsOwnersFirstAscendingName(toIds) {
  const sortByName = (e1, e2) => e1.displayName.localeCompare(e2.displayName);
  const owners = selectOwners(toIds).sort(sortByName);
  const collaborators = selectCollaborators(toIds).sort(sortByName);
  return [...owners, ...collaborators];
}

export default function ToIdsV2({
  employees,
  onUpdate,
  className,
  popUpDivId = '',
  leftGutter = -0.75,
  iconSize = 'tiny',
  renderEmptyView,
  maxNodes = 4,
  disableOnClick = false,
}) {
  const sortedCurrentOwners = sortToIdsOwnersFirstAscendingName(employees);
  const [ownerPopupAnchor, setownerPopupAnchor] = useState(null);

  function onClick(e) {
    if (disableOnClick) return;
    e?.preventDefault();
    e?.stopPropagation();
    if (ownerPopupAnchor) {
      setownerPopupAnchor(null);
      return;
    }
    const nodesView = e.currentTarget?.closest('.nodesView');
    setownerPopupAnchor(nodesView || e.currentTarget);
  }

  const menuId = useMemo(() => generateKey(5), []);

  return (
    <NodesViewV2
      className={className}
      employees={sortedCurrentOwners}
      maxNodes={maxNodes}
      renderAvatar={(props) => <EmployeeOwnerAvatar {...props} size={iconSize} element />}
      useEmployeeClick={false}
      onClick={onClick}
      renderNodesEditView={() => (
        <MeshListEmployeeEditPopup
          ownerEditPopupId={popUpDivId}
          ownerPopupAnchor={ownerPopupAnchor}
          setownerPopupAnchor={setownerPopupAnchor}
          employees={sortedCurrentOwners}
          onUpdate={onUpdate}
        />
      )}
      renderEmptyView={renderEmptyView}
      leftGutter={leftGutter}
    />
  );
}
